import { connect } from 'react-redux'
import { IStoreState, IMobilityOptionObject } from '../../types/index'
import {
  getMobilityOptions,
  getMobilityOptionCategories,
  updateMobilityOption
} from 'src/state/actions/mobility-options'
import EditMobilityDeviceModal from 'src/components/global-settings/EditMobilityDeviceModal'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    categories: state.mobilityOptionsCategories.items,
    devices: state.mobilityOptions.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    update: (mobility: IMobilityOptionObject) => {
      return dispatch(updateMobilityOption(mobility))
    },
    getMobilityOptions: () => {
      return dispatch(getMobilityOptions())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditMobilityDeviceModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/EditMobilityDeviceModal.ts